import { useMemo, useState } from 'react';

import {
    DataState,
    ERROR_DATA_STATE,
    INITIAL_DATA_STATE,
    LOADING_DATA_STATE,
    SUCCESS_DATA_STATE,
} from '@/types/data.type';

export function useDataState() {
    const [dataState, setDataState] = useState<DataState>(INITIAL_DATA_STATE);

    const { setInitial, setLoading, setSuccess, setError } = useMemo(() => {
        return {
            setInitial: () => setDataState(INITIAL_DATA_STATE),
            setLoading: () => setDataState(LOADING_DATA_STATE),
            setSuccess: () => setDataState(SUCCESS_DATA_STATE),
            setError: () => setDataState(ERROR_DATA_STATE),
        };
    }, [setDataState]);

    return {
        dataState,
        isInitial: dataState === INITIAL_DATA_STATE,
        isLoading: dataState === LOADING_DATA_STATE,
        isSuccess: dataState === SUCCESS_DATA_STATE,
        isError: dataState === ERROR_DATA_STATE,
        setInitial,
        setLoading,
        setSuccess,
        setError,
    };
}
